// Supported languages
export type Language = 'da' | 'en';

// Translation key type
export type TranslationKey = 
  | 'app.name'
  | 'app.nav.home'
  | 'app.nav.what_is_it'
  | 'app.nav.why'
  | 'app.home.title'
  | 'app.home.title_highlight'
  | 'app.home.description'
  | 'app.home.feature1.title'
  | 'app.home.feature1.description'
  | 'app.home.feature2.title'
  | 'app.home.feature2.description'
  | 'app.home.feature3.title'
  | 'app.home.feature3.description'
  | 'app.what.title'
  | 'app.what.description1'
  | 'app.what.description2'
  | 'app.what.capabilities_intro'
  | 'app.what.capability1'
  | 'app.what.capability2'
  | 'app.what.capability3'
  | 'app.what.capability4'
  | 'app.what.capability6'
  | 'app.what.conclusion'
  | 'app.why.title'
  | 'app.why.reason1.title'
  | 'app.why.reason1.description'
  | 'app.why.reason2.title'
  | 'app.why.reason2.description'
  | 'app.why.reason3.title'
  | 'app.why.reason3.description'
  | 'app.why.reason4.title'
  | 'app.why.reason4.description'
  | 'app.footer.rights'
  | 'app.footer.privacy'
  | 'book.investment_calculator'
  | 'book.current_amount'
  | 'book.expected_future_value'
  | 'book.annual_return_rate'
  | 'book.investment_period'
  | 'book.year_single'
  | 'book.year_plural'
  | 'book.value_development'
  | 'book.value'
  | 'book.year'
  | 'book.start'
  | 'book.investment_note'
  | 'book.investment_details'
  | 'book.investment_details_description'
  | 'book.custom_payment_info_description'
  | 'book.bank_name'
  | 'book.bank_name_placeholder'
  | 'book.account_number'
  | 'book.account_number_placeholder'
  | 'book.payment_reference'
  | 'book.payment_reference_placeholder'
  | 'book.additional_payment_info'
  | 'book.additional_payment_info_placeholder'
  | 'occasion.create_new'
  | 'occasion.create_description'
  | 'occasion.title'
  | 'occasion.title_placeholder'
  | 'occasion.date'
  | 'occasion.location'
  | 'occasion.location_placeholder'
  | 'occasion.type'
  | 'occasion.physical'
  | 'occasion.online'
  | 'occasion.description'
  | 'occasion.description_placeholder'
  | 'occasion.choose_invitation_card'
  | 'occasion.invitation_message'
  | 'occasion.invitation_message_placeholder'
  | 'occasion.wishlist'
  | 'occasion.enable_wishlist'
  | 'occasion.wishlist_url'
  | 'occasion.wishlist_url_placeholder'
  | 'occasion.deleted_title'
  | 'occasion.deleted_description'
  | 'occasion.delete_error'
  | 'occasion.delete_confirm'
  | 'occasion.no_occasions_title'
  | 'occasion.no_occasions_description'
  | 'occasion.create_first'
  | 'occasion.guests_invited'
  | 'occasion.no_guests_yet'
  | 'occasion.share_invitation'
  | 'occasion.select_date'
  | 'occasion.invites_and_wishlist'
  | 'occasion.invitees_emails'
  | 'occasion.emails_placeholder'
  | 'occasion.invitees_description'
  | 'occasion.include_wishlist'
  | 'occasion.wishlist_description'
  | 'occasion.wishlist_invitees_label'
  | 'occasion.wishlist_invitees_description'
  | 'occasion.creating'
  | 'occasion.create_button'
  | 'occasion.update_button'
  | 'occasion.created_title'
  | 'occasion.created_description'
  | 'occasion.updated_title'
  | 'occasion.updated_description'
  | 'occasion.create_error'
  | 'occasion.update_error'
  | 'occasion.edit_title'
  | 'occasion.edit_description'
  | 'occasion.rsvp_deadline'
  | 'occasion.select_rsvp_deadline'
  | 'occasion.rsvp_contact'
  | 'occasion.rsvp_contact_placeholder'
  | 'occasion.send_invitations'
  | 'occasion.send_invitations_description'
  | 'occasion.send_invitations_button'
  | 'occasion.sending_invitations'
  | 'occasion.invitations_sent'
  | 'occasion.invitations_sent_description'
  | 'occasion.send_invitation_error'
  | 'occasion.no_guests_title'
  | 'occasion.no_guests_to_invite'
  | 'occasion.no_guests_added'
  | 'occasion.add_guests_first'
  | 'occasion.event_details'
  | 'occasion.regular_invitees'
  | 'occasion.wishlist_invitees'
  | 'occasion.personal_message_optional'
  | 'occasion.personal_message_placeholder'
  | 'occasion.guest_management'
  | 'occasion.total_guests'
  | 'occasion.all_guests'
  | 'occasion.confirmed'
  | 'occasion.pending'
  | 'occasion.declined'
  | 'occasion.no_confirmed_guests'
  | 'occasion.no_pending_guests'
  | 'occasion.no_declined_guests'
  | 'occasion.edit'
  | 'occasion.delete'
  | 'occasion.resend_button'
  | 'occasion.resend_modal_title'
  | 'occasion.resend_modal_description'
  | 'occasion.resend_button_sending'
  | 'occasion.resend_button_send'
  | 'occasion.resend_success_title'
  | 'occasion.resend_success_description'
  | 'occasion.resend_error_invalid_title'
  | 'occasion.resend_error_invalid_description'
  | 'gift_detail.title'
  | 'gift_detail.contribution_to_wish'
  | 'gift_detail.ambition_gift'
  | 'gift_detail.life_advice'
  | 'gift_detail.life_advice_value'
  | 'gift_detail.personal_message'
  | 'gift_detail.meaningfulness'
  | 'gift_detail.attachments'
  | 'gift_detail.attachment_file'
  | 'gift_detail.bucket_list'
  | 'gift_detail.add_to_bucket'
  | 'gift_detail.remove_from_bucket'
  | 'gift_detail.rating_saved'
  | 'gift_detail.rating_saved_description'
  | 'gift_detail.bucket_status_updated'
  | 'gift_detail.added_to_bucket'
  | 'gift_detail.removed_from_bucket'
  | 'gift_detail.error'
  | 'gift_detail.rating_error'
  | 'gift_detail.payment_confirmed'
  | 'gift_detail.payment_confirmed_description'
  | 'gift_detail.payment_error'
  | 'gift_detail.confirm_payment'
  | 'gift_detail.reaction_video'
  | 'gift_detail.no_reaction_video'
  | 'gift_detail.record_reaction'
  | 'gift_detail.recorded'
  | 'gift_detail.unknown_date'
  | 'gift_detail.payment_status'
  | 'gift_detail.confirm_payment_button'
  | 'gift_detail.send_reminder'
  | 'bucket_list.title'
  | 'bucket_list.collected_experiences'
  | 'bucket_list.empty_list'
  | 'bucket_list.empty_description'
  | 'bucket_list.from'
  | 'bucket_list.item_default'
  | 'bucket_list.sending'
  | 'bucket_list.send_email'
  | 'bucket_list.generating'
  | 'bucket_list.download_pdf'
  | 'bucket_list.close'
  | 'bucket_list.success_title'
  | 'bucket_list.success_description'
  | 'bucket_list.email_success_title'
  | 'bucket_list.email_success_description'
  | 'bucket_list.pdf_error_title'
  | 'bucket_list.pdf_error_description'
  | 'bucket_list.email_error_title'
  | 'bucket_list.email_error_description'
  | 'bucket_list.send_email_title'
  | 'bucket_list.email_subheading'
  | 'bucket_list.recipient_email'
  | 'bucket_list.email_placeholder'
  | 'bucket_list.personal_message_optional'
  | 'bucket_list.message_placeholder'
  | 'bucket_list.cancel'
  | 'bucket_list.send'
  | 'bucket_list.email_validation_title'
  | 'bucket_list.email_validation_description'
  | 'dashboard.delete_book'
  | 'dashboard.book_deleted'
  | 'dashboard.book_delete_error'
  | 'dashboard.delete_confirmation_title'
  | 'dashboard.delete_confirmation_description'
  | 'dashboard.type_name_to_confirm'
  | 'dashboard.confirm_delete'
  | 'dashboard.cancel'
  | 'app.login'
  | 'app.signup'
  | 'app.logout'
  | 'app.back'
  | 'app.back_to_dashboard'
  | 'app.welcome'
  | 'app.details'
  | 'app.or_continue_with'
  | 'app.email'
  | 'app.password'
  | 'app.forgot_password'
  | 'app.have_account'
  | 'app.no_account'
  | 'app.create_account'
  | 'app.full_name'
  | 'dashboard.title'
  | 'dashboard.welcome'
  | 'dashboard.create_book'
  | 'dashboard.your_books'
  | 'dashboard.no_books'
  | 'dashboard.no_books_description'
  | 'dashboard.user'
  | 'dashboard.profile_picture'
  | 'dashboard.about_gratimy'
  | 'dashboard.open'
  | 'dashboard.years_old'
  | 'dashboard.new'
  | 'dashboard.gifts'
  | 'dashboard.updated'
  | 'dashboard.share_book'
  | 'create_book.back'
  | 'create_book.title'
  | 'create_book.child_name'
  | 'create_book.birth_date'
  | 'create_book.theme'
  | 'create_book.welcome_message'
  | 'create_book.cover_image'
  | 'create_book.cover_image_upload'
  | 'create_book.profile_picture'
  | 'create_book.profile_picture_upload'
  | 'create_book.sharing_features'
  | 'create_book.share_with_family'
  | 'create_book.share_description'
  | 'create_book.allow_financial_gifts'
  | 'create_book.financial_gifts_description'
  | 'create_book.payment_info'
  | 'create_book.payment_info_description'
  | 'create_book.child_name_placeholder'
  | 'create_book.welcome_message_placeholder'
  | 'create_book.select_theme'
  | 'create_book.upload_format'
  | 'create_book.theme_standard'
  | 'create_book.theme_adventure'
  | 'create_book.theme_space'
  | 'create_book.theme_nature'
  | 'create_book.bank_account_placeholder'
  | 'create_book.routing_number_placeholder'
  | 'create_book.iban_placeholder'
  | 'create_book.swift_placeholder'
  | 'create_book.mobile_pay_placeholder'
  | 'create_book.venmo_placeholder'
  | 'create_book.paypal_placeholder'
  | 'create_book.show_bank_transfer'
  | 'create_book.show_mobile_pay'
  | 'create_book.show_venmo'
  | 'create_book.show_paypal'
  | 'create_book.account_number'
  | 'create_book.routing_number'
  | 'create_book.iban'
  | 'create_book.swift'
  | 'create_book.mobile_pay'
  | 'create_book.venmo'
  | 'create_book.paypal'
  | 'create_book.creating'
  | 'create_book.file_too_large'
  | 'create_book.file_too_large_desc'
  | 'create_book.invalid_file_type'
  | 'create_book.invalid_file_type_desc'
  | 'create_book.profile_uploaded'
  | 'create_book.profile_uploaded_desc'
  | 'create_book.profile_upload_failed_desc'
  | 'create_book.cover_uploaded'
  | 'create_book.cover_uploaded_desc'
  | 'create_book.cover_upload_failed_desc'
  | 'create_book.upload_failed'
  | 'create_book.uploading'
  | 'create_book.uploading_images'
  | 'create_book.success_title'
  | 'create_book.success_message'
  | 'book.add_gift'
  | 'book.share'
  | 'book.share_description'
  | 'book.share_title'
  | 'book.share_emails'
  | 'book.share_emails_placeholder'
  | 'book.share_personal_message'
  | 'book.share_personal_message_placeholder'
  | 'book.share_allow_editing'
  | 'book.share_allow_editing_description'
  | 'book.share_sending'
  | 'book.share_send'
  | 'book.share_or'
  | 'book.share_copy_link'
  | 'book.share_generating_link'
  | 'book.share_invite_sent_title'
  | 'book.share_invite_sent_description'
  | 'book.share_error_title'
  | 'book.share_error_description'
  | 'book.share_link_copied_title'
  | 'book.share_link_copied_description'
  | 'book.share_link_error_title'
  | 'book.share_link_error_description'
  | 'book.share_link_copied_again_title'
  | 'book.share_link_copied_again_description'
  | 'book.not_found'
  | 'book.back_to_overview'
  | 'book.open'
  | 'book.gifts'
  | 'book.goals'
  | 'book.occasions'
  | 'book.possessive'
  | 'book.title'
  | 'book.birthday'
  | 'book.gift_entries'
  | 'book.age'
  | 'book.default_welcome'
  | 'book.personal_messages'
  | 'book.life_advice'
  | 'book.life_advice_for'
  | 'book.gift_from'
  | 'book.no_message'
  | 'book.no_gifts_yet'
  | 'book.no_gifts_description'
  | 'book.created'
  | 'book.new_entries'
  | 'book.goals_error'
  | 'book.goals_description'
  | 'book.create_new_goal'
  | 'book.contributor_single'
  | 'book.contributor_plural'
  | 'book.future_value_details'
  | 'book.expected_future_value'
  | 'book.current_value'
  | 'book.investment_period'
  | 'book.years'
  | 'book.of'
  | 'book.achieved'
  | 'book.no_goals_yet'
  | 'book.no_goals_description'
  | 'book.occasion_deleted'
  | 'book.occasion_deleted_description'
  | 'book.occasion_delete_error'
  | 'book.confirm_delete_occasion'
  | 'book.no_occasions_yet'
  | 'book.no_occasions_description'
  | 'book.create_first_occasion'
  | 'book.preview_invitation'
  | 'book.edit_occasion'
  | 'book.delete_occasion'
  | 'book.guests_invited'
  | 'book.no_guests_invited'
  | 'book.location_physical'
  | 'book.location_online'
  | 'book.view_invitation'
  | 'app.error'
  | 'book.annual_interest_rate'
  | 'book.create_new_goal_title'
  | 'book.regular_wish'
  | 'book.stock_fund'
  | 'book.title_label'
  | 'book.title_placeholder'
  | 'book.description_label'
  | 'book.description_placeholder'
  | 'book.target_amount'
  | 'book.initial_amount'
  | 'book.payment_information'
  | 'book.add_custom_payment_info'
  | 'book.cancel'
  | 'book.create_wish'
  | 'book.create_fund'
  | 'book.creating'
  | 'book.edit_goal_title'
  | 'book.update_wish'
  | 'book.update_fund'
  | 'book.updating'
  | 'book.create_new_occasion'
  | 'book.bucket_list_wishes'
  | 'book.sort_by'
  | 'book.newest_first'
  | 'book.by_giver'
  | 'book.by_meaningful'
  | 'book.by_advice'
  | 'book.by_bucket'
  | 'book.show_all_gifts'
  | 'book.show_bucket_only'
  | 'book.gifts_by_occasion'
  | 'book.other_occasion'
  | 'book.wishes_and_inspiration'
  | 'book.personal_messages'
  | 'book.life_advice_section'
  | 'book.bucket_list_section'
  | 'book.gift_default_title'
  | 'book.edit_wish_aria'
  | 'book.wish_preview_title'
  | 'book.wish_preview_contributors'
  | 'book.wish_preview_no_contributors'
  | 'book.wish_preview_edit'
  | 'book.anonymous'
  | 'add_gift.select_goal_placeholder'
  | 'validation.occasion_required'
  | 'validation.giver_name_required'
  | 'validation.relation_required'
  | 'validation.occasion_date_required'
  | 'validation.personal_message_required'
  | 'add_gift.giver_name'
  | 'add_gift.giver_name_placeholder'
  | 'add_gift.relation_label'
  | 'add_gift.relation_subtitle'
  | 'add_gift.relation_placeholder'
  | 'add_gift.relation_description'
  | 'add_gift.gift_amount_label'
  | 'add_gift.currency'
  | 'add_gift.occasion_date_label'
  | 'add_gift.ambition_gift_title_label'
  | 'add_gift.ambition_gift_title_placeholder'
  | 'add_gift.ambition_gift_title_description'
  | 'add_gift.ambition_gift_label'
  | 'add_gift.ambition_gift_subtitle'
  | 'add_gift.ambition_gift_placeholder'
  | 'add_gift.life_advice_label'
  | 'add_gift.life_advice_optional'
  | 'add_gift.life_advice_placeholder'
  | 'add_gift.personal_message_label'
  | 'add_gift.personal_message_required'
  | 'add_gift.personal_message_placeholder'
  | 'add_gift.thank_you_title'
  | 'add_gift.thank_you_message'
  | 'add_gift.payment_info_title'
  | 'add_gift.special_payment_info'
  | 'add_gift.payment_instructions_custom'
  | 'add_gift.payment_instructions_fund'
  | 'add_gift.payment_fund_label'
  | 'add_gift.payment_bank_label'
  | 'add_gift.payment_account_label'
  | 'add_gift.payment_reference_label'
  | 'add_gift.payment_routing_label'
  | 'add_gift.payment_sort_code_label'
  | 'add_gift.payment_iban_label'
  | 'add_gift.payment_bic_swift_label'
  | 'add_gift.payment_method_bank_transfer'
  | 'add_gift.payment_method_mobilepay'
  | 'add_gift.payment_method_venmo'
  | 'add_gift.payment_method_paypal'
  | 'add_gift.default_payment_info_title'
  | 'add_gift.default_payment_info_description'
  | 'add_gift.payment_no_methods_message'
  | 'add_gift.standard_payment_info'
  | 'add_gift.fund'
  | 'add_gift.wish'
  | 'add_gift.occasion_label'
  | 'add_gift.save_gift_entry'
  | 'add_gift.step_occasion_giver'
  | 'add_gift.step_gift_details'
  | 'add_gift.step_messages_submit'
  | 'add_gift.step_messages'
  | 'add_gift.step_consent_submit'
  | 'add_gift.form_title'
  | 'add_gift.form_subtitle'
  | 'add_gift.cancel'
  | 'add_gift.gift_table'
  | 'add_gift.consent_intro'
  | 'add_gift.validation_relation_max'
  | 'add_gift.validation_amount_invalid'
  | 'add_gift.validation_terms_required'
  | 'add_gift.validation_gdpr_required'
  | 'public_gift.page_title'
  | 'public_gift.form_title'
  | 'public_gift.form_subtitle'
  | 'public_gift.gift_information'
  | 'public_gift.your_name'
  | 'public_gift.your_name_placeholder'
  | 'public_gift.your_email'
  | 'public_gift.your_email_placeholder'
  | 'public_gift.your_relation'
  | 'public_gift.relation_subtitle'
  | 'public_gift.relation_placeholder'
  | 'public_gift.relation_description'
  | 'public_gift.occasion_details'
  | 'public_gift.select_occasion'
  | 'public_gift.select_occasion_placeholder'
  | 'public_gift.custom_occasion'
  | 'public_gift.planned_occasions'
  | 'public_gift.occasion_name_placeholder'
  | 'public_gift.occasion_name_hint'
  | 'public_gift.occasion_date'
  | 'public_gift.set_arrival_time'
  | 'public_gift.arrival_time_description'
  | 'public_gift.arrival_date'
  | 'public_gift.arrival_time'
  | 'public_gift.your_timezone'
  | 'public_gift.timezone_note'
  | 'public_gift.gift_details'
  | 'public_gift.gift_amount'
  | 'public_gift.optional'
  | 'public_gift.currency'
  | 'public_gift.select_goal'
  | 'public_gift.select_goal_placeholder'
  | 'public_gift.no_specific_goal'
  | 'public_gift.current_value'
  | 'public_gift.of'
  | 'public_gift.or_add_your_own'
  | 'public_gift.dream_gift_title'
  | 'public_gift.dream_gift_title_placeholder'
  | 'public_gift.dream_gift_title_hint'
  | 'public_gift.dream_gift_description'
  | 'public_gift.dream_gift_description_placeholder'
  | 'public_gift.personal_messages'
  | 'public_gift.personal_message'
  | 'public_gift.personal_message_placeholder'
  | 'public_gift.life_advice'
  | 'public_gift.life_advice_placeholder'
  | 'public_gift.payment_information'
  | 'public_gift.special_payment_for'
  | 'public_gift.fund'
  | 'public_gift.wish'
  | 'public_gift.payment_instructions_custom'
  | 'public_gift.special_payment_to_fund'
  | 'public_gift.payment_instructions_fund'
  | 'public_gift.payment_bank_label'
  | 'public_gift.payment_account_label'
  | 'public_gift.payment_reference_label'
  | 'public_gift.payment_fund_label'
  | 'public_gift.payment_routing_label'
  | 'public_gift.payment_sort_code_label'
  | 'public_gift.payment_iban_label'
  | 'public_gift.payment_bic_swift_label'
  | 'public_gift.default_payment_info_title'
  | 'public_gift.default_payment_info_description'
  | 'public_gift.payment_no_methods_message'
  | 'public_gift.payment_method_bank_transfer'
  | 'public_gift.payment_method_mobilepay'
  | 'public_gift.payment_method_venmo'
  | 'public_gift.payment_method_paypal'
  | 'public_gift.payment_email_note'
  | 'public_gift.agree_to_terms'
  | 'public_gift.terms_of_service'
  | 'public_gift.agree_to_gdpr'
  | 'public_gift.privacy_policy'
  | 'public_gift.marketing_consent'
  | 'public_gift.consent_terms_text'
  | 'public_gift.consent_gdpr_text'
  | 'public_gift.consent_gdpr_helper'
  | 'public_gift.consent_marketing_text'
  | 'gift_flow.step_choose_gift'
  | 'gift_flow.step_occasion'
  | 'gift_flow.step_messages'
  | 'gift_flow.step_who_you_are'
  | 'gift_flow.step_review_send'
  | 'gift_flow.ambition_label'
  | 'gift_flow.wish_label'
  | 'gift_flow.give_ambition_title'
  | 'gift_flow.ambition_card_description'
  | 'gift_flow.gifted_so_far'
  | 'gift_flow.contributions_one'
  | 'gift_flow.contributions_many'
  | 'gift_flow.ambition_gifts_one'
  | 'gift_flow.ambition_gifts_many'
  | 'gift_flow.raised_of_goal'
  | 'gift_flow.no_contributions_yet'
  | 'gift_flow.opened_this_gift'
  | 'gift_flow.ambition_byline'
  | 'gift_flow.recent_contributions'
  | 'gift_flow.recent_ambition_gifts'
  | 'gift_flow.names_visible_note'
  | 'gift_flow.continue_with_gift'
  | 'gift_flow.direct_payment_note'
  | 'gift_flow.amount_optional'
  | 'gift_flow.just_because_title'
  | 'gift_flow.just_because_description'
  | 'gift_flow.own_event_description'
  | 'gift_flow.scheduling_title'
  | 'gift_flow.appears_immediately_helper'
  | 'gift_flow.appears_on'
  | 'gift_flow.appears_immediately'
  | 'gift_flow.change_timing'
  | 'gift_flow.why_matters_title'
  | 'gift_flow.why_matters_body'
  | 'gift_flow.review_intro'
  | 'gift_flow.review_gift'
  | 'gift_flow.review_amount'
  | 'gift_flow.review_occasion'
  | 'gift_flow.review_when'
  | 'gift_flow.review_from'
  | 'gift_flow.review_message'
  | 'gift_flow.visibility_title'
  | 'gift_flow.visibility_helper'
  | 'gift_flow.show_name_label'
  | 'gift_flow.show_amount_label'
  | 'gift_flow.consent_on_file'
  | 'gift_flow.welcome_title'
  | 'gift_flow.draft_saved'
  | 'gift_flow.choose_gift_required'
  | 'public_gift.step_about_you'
  | 'public_gift.step_occasion_gift'
  | 'public_gift.step_messages'
  | 'public_gift.step_consent'
  | 'public_gift.back'
  | 'public_gift.next'
  | 'public_gift.cancel'
  | 'public_gift.submit_gift'
  | 'public_gift.send_greeting'
  | 'public_gift.greeting_page_title'
  | 'public_gift.greeting_form_title'
  | 'public_gift.greeting_form_subtitle'
  | 'public_gift.greeting_your_info'
  | 'public_gift.greeting_message_label'
  | 'public_gift.greeting_message_placeholder'
  | 'share.greeting_mode_label'
  | 'share.greeting_mode_description'
  | 'share.copy_greeting_link'
  | 'share.copy_public_link'
  | 'share.greeting_link_copied'
  | 'share.greeting_link_copied_description'
  | 'share.greeting_link_ready'
  | 'share.greeting_link_error'
  | 'public_gift.submission_success'
  | 'public_gift.submission_success_message'
  | 'public_gift.submission_failed'
  | 'public_gift.submission_failed_message'
  | 'public_gift.invalid_link'
  | 'public_gift.thank_you'
  | 'public_gift.thank_you_message'
  | 'public_gift.return_home'
  | 'public_gift.confirm.gift_registered'
  | 'public_gift.confirm.thank_you_intro'
  | 'public_gift.confirm.email_copy_sent'
  | 'public_gift.confirm.gift_details_title'
  | 'public_gift.confirm.label_for'
  | 'public_gift.confirm.label_from'
  | 'public_gift.confirm.label_occasion'
  | 'public_gift.confirm.label_amount'
  | 'public_gift.confirm.label_submitted'
  | 'public_gift.confirm.label_gift_id'
  | 'public_gift.confirm.your_message'
  | 'public_gift.confirm.payment_information_title'
  | 'public_gift.confirm.payment_use_details'
  | 'public_gift.confirm.label_bank'
  | 'public_gift.confirm.label_account'
  | 'public_gift.confirm.label_reference'
  | 'public_gift.confirm.label_note'
  | 'public_gift.confirm.label_fund'
  | 'public_gift.confirm.label_reg_number'
  | 'public_gift.confirm.label_sort_code'
  | 'public_gift.confirm.label_routing'
  | 'public_gift.confirm.payment_empty_state'
  | 'public_gift.confirm.email_not_delivered_title'
  | 'public_gift.confirm.email_not_delivered_desc'
  | 'public_gift.confirm.label_iban'
  | 'public_gift.confirm.label_swift'
  | 'public_gift.confirm.us_split_title'
  | 'public_gift.confirm.us_split_routing'
  | 'public_gift.confirm.us_split_account_prefix'
  | 'public_gift.confirm.us_split_account_suffix'
  | 'public_gift.confirm.us_split_both'
  | 'public_gift.confirm.download_pdf'
  | 'public_gift.confirm.preparing_receipt'
  | 'public_gift.confirm.receipt_only_once_warning'
  | 'public_gift.confirm.receipt_unavailable_title'
  | 'public_gift.confirm.receipt_unavailable_desc'
  | 'public_gift.confirm.receipt_download_error_title'
  | 'public_gift.confirm.receipt_download_error_desc'
  | 'public_gift.confirm.nudge_error_title'
  | 'public_gift.confirm.nudge_error_desc'
  | 'public_gift.confirm.friend_fallback'
  | 'public_gift.link_deactivated_title'
  | 'public_gift.link_deactivated_desc'
  | 'public_gift.link_expired_title'
  | 'public_gift.link_expired_desc'
  | 'public_gift.og_description'
  | 'app.take_tour'
  | 'dashboard.type_to_confirm'
  | 'common.cancel'
  | 'common.deleting'
  | 'common.delete'
  | 'book.adjust_cover_position'
  | 'book.load_error_message'
  | 'book.load_error_title'
  | 'book.position_saved_desc'
  | 'book.position_saved_title'
  | 'book.position_save_error_desc'
  | 'book.position_save_error_title'
  | 'book.scroll_left'
  | 'book.scroll_right'
  | 'book.view_all_gifts'
  | 'share.manage_links'
  | 'share.no_links'
  | 'share.deactivate'
  | 'share.deactivated'
  | 'share.deactivate_confirm_title'
  | 'share.deactivate_confirm_desc'
  | 'share.deactivate_confirm_button'
  | 'share.deactivate_cancel'
  | 'share.deactivate_success'
  | 'share.deactivate_success_desc'
  | 'share.deactivate_error'
  | 'share.deactivate_error_desc'
  | 'share.generate_new_link'
  | 'share.share_title'
  | 'share.share_description'
  | 'share.email_label'
  | 'share.email_placeholder'
  | 'share.message_label'
  | 'share.message_placeholder'
  | 'share.allow_edit'
  | 'share.allow_edit_desc'
  | 'share.send_invitation'
  | 'share.sending_invitation'
  | 'share.or'
  | 'share.copy_link'
  | 'share.generating_link'
  | 'share.link_copied'
  | 'share.link_copied_desc'
  | 'share.link_copied_again'
  | 'share.link_copied_again_desc'
  | 'share.share_error'
  | 'share.share_error_desc'
  | 'share.link_error'
  | 'share.link_error_desc'
  | 'share.invitation_sent'
  | 'share.invitation_sent_desc'
  | 'share.email_required'
  | 'add_gift.custom_occasion'
  | 'add_gift.select_occasion_placeholder'
  | 'add_gift.planned_occasions'
  | 'add_gift.occasion_name_placeholder'
  | 'add_gift.write_occasion_name'
  | 'add_gift.success_title'
  | 'add_gift.success_description'
  | 'add_gift.error_title'
  | 'add_gift.error_description'
  | 'add_gift.back'
  | 'add_gift.next'
  | 'add_gift.page_title'
  | 'add_gift.owner_success_intro'
  | 'add_gift.owner_success_back_to_book'
  | 'add_gift.owner_success_add_another'
  | 'landing.home'
  | 'landing.whatIsIt'
  | 'landing.why'
  | 'landing.createMemories'
  | 'landing.forLife'
  | 'landing.heroDescription'
  | 'landing.getStarted'
  | 'landing.readMore'
  | 'landing.preserveMemories'
  | 'landing.preserveMemoriesDesc'
  | 'landing.setupGoals'
  | 'landing.setupGoalsDesc'
  | 'landing.shareEvents'
  | 'landing.shareEventsDesc'
  | 'landing.whatIsGratimy'
  | 'landing.whatIsGratimyDesc1'
  | 'landing.whatIsGratimyDesc2'
  | 'landing.whatYouCanDo'
  | 'landing.createBooks'
  | 'landing.invitePeople'
  | 'landing.defineGoals'
  | 'landing.createInvitations'
  | 'landing.rateGifts'
  | 'landing.beautifulDesign'
  | 'landing.whyChoose'
  | 'landing.preserveImportantMoments'
  | 'landing.preserveImportantMomentsDesc'
  | 'landing.meaningfulPlanning'
  | 'landing.meaningfulPlanningDesc'
  | 'landing.strengthenFamilyBonds'
  | 'landing.strengthenFamilyBondsDesc'
  | 'landing.simpleSecurePlatform'
  | 'landing.simpleSecurePlatformDesc'
  | 'landing.startJourney'
  | 'landing.copyright'
  | 'landing.privacyPolicy'
  | 'landing.terms'
  | 'landing.contact'
  | 'landing.manageCookies'
  | 'cookies.title'
  | 'cookies.description'
  | 'cookies.essential.title'
  | 'cookies.essential.description'
  | 'cookies.analytics.title'
  | 'cookies.analytics.description'
  | 'cookies.marketing.title'
  | 'cookies.marketing.description'
  | 'cookies.preferences.title'
  | 'cookies.preferences.description'
  | 'cookies.acceptAll'
  | 'cookies.acceptEssential'
  | 'cookies.rejectNonEssential'
  | 'cookies.savePreferences'
  | 'cookies.customize'
  | 'cookies.hideDetails'
  | 'cookies.doNotTrackNotice'
  | 'cookies.required'
  | 'trust.privacy_link'
  | 'trust.public_gift'
  | 'trust.create_book_payment'
  | 'trust.payment_info_stripe'
  | 'dashboard.loadError'
  | 'dashboard.loadErrorMessage'
  | 'dashboard.trialActive'
  | 'dashboard.daysLeft'
  | 'dashboard.premiumFeaturesOn'
  | 'dashboard.premiumFeaturesFirstBook'
  | 'dashboard.premiumScheduledTitle'
  | 'dashboard.premiumScheduled'
  | 'dashboard.viewDetails'
  | 'dashboard.trialAvailable'
  | 'dashboard.unlockPremium'
  | 'dashboard.activateNow'
  | 'dashboard.trialEnded'
  | 'dashboard.booksViewOnly'
  | 'dashboard.haveGiftCode'
  | 'dashboard.upgrade'
  | 'dashboard.upgradeToPremium'
  | 'dashboard.subscribeToUnlock'
  | 'dashboard.firstPaymentDelay'
  | 'dashboard.createNewBook'
  | 'dashboard.startCollection'
  | 'dashboard.upgradeForMoreBooks'
  | 'dashboard.checkoutSuccess'
  | 'dashboard.checkoutSuccessDesc'
  | 'dashboard.openYourBook'
  | 'dashboard.continueToDashboard'
  | 'dashboard.ownershipCongrats'
  | 'dashboard.ownershipMessage'
  | 'dashboard.continueDashboard'
  | 'paymentInfo.dashboard'
  | 'paymentInfo.subscriptionOverview'
  | 'paymentInfo.managePlanBilling'
  | 'paymentInfo.trialAvailableTitle'
  | 'paymentInfo.trialAvailableDesc'
  | 'paymentInfo.featureShareFamily'
  | 'paymentInfo.featureCustomPayment'
  | 'paymentInfo.featureOccasionsRSVP'
  | 'paymentInfo.featureFreeInvitations'
  | 'paymentInfo.activating'
  | 'paymentInfo.activateTrial'
  | 'paymentInfo.trialActiveLabel'
  | 'paymentInfo.premiumAndTrialActiveTitle'
  | 'paymentInfo.trialContinuesNoCharge'
  | 'paymentInfo.premiumScheduledTitle'
  | 'paymentInfo.premiumScheduledDesc'
  | 'paymentInfo.firstPaymentOn'
  | 'paymentInfo.activeStatus'
  | 'paymentInfo.yourFirstBook'
  | 'paymentInfo.expiresLabel'
  | 'paymentInfo.subscribeNowDelay'
  | 'paymentInfo.redirecting'
  | 'paymentInfo.upgradeToPremium'
  | 'paymentInfo.trialEndedTitle'
  | 'paymentInfo.trialEndedDesc'
  | 'paymentInfo.viewPlans'
  | 'paymentInfo.addBook'
  | 'paymentInfo.plans'
  | 'paymentInfo.booksLabel'
  | 'paymentInfo.totalLabel'
  | 'paymentInfo.premiumLabel'
  | 'paymentInfo.noBooksYet'
  | 'paymentInfo.createFirstBook'
  | 'paymentInfo.tabOverview'
  | 'paymentInfo.tabPayment'
  | 'paymentInfo.tabHistory'
  | 'paymentInfo.featBasicFunctions'
  | 'paymentInfo.featShareFamily'
  | 'paymentInfo.featCustomPayment'
  | 'paymentInfo.featOccasions'
  | 'paymentInfo.featBulkDiscounts'
  | 'paymentInfo.yearTotal'
  | 'paymentInfo.savedAmount'
  | 'paymentInfo.yearlyAutoRenew'
  | 'paymentInfo.viewAllPlans'
  | 'paymentInfo.loading'
  | 'paymentInfo.cancelSubscription'
  | 'paymentInfo.defaultLabel'
  | 'paymentInfo.editLabel'
  | 'paymentInfo.removeLabel'
  | 'paymentInfo.noPaymentMethods'
  | 'paymentInfo.updatePaymentMethod'
  | 'paymentInfo.addPaymentMethod'
  | 'paymentInfo.noHistory'
  | 'paymentInfo.downloadLatest'
  | 'paymentInfo.downloadPdf'
  | 'paymentInfo.viewInvoice'
  | 'paymentInfo.trialActivatedTitle'
  | 'paymentInfo.trialActivatedDesc'
  | 'paymentInfo.errorTitle'
  | 'paymentInfo.trialActivateError'
  | 'paymentInfo.expires'
  | 'createBook.validationChildName'
  | 'createBook.validationBirthdate'
  | 'createBook.bookCreated'
  | 'createBook.bookCreatedDesc'
  | 'createBook.createError'
  | 'createBook.createErrorDesc'
  | 'createBook.paymentProcessing'
  | 'createBook.paymentProcessingDesc'
  | 'createBook.checkoutCancelled'
  | 'createBook.checkoutCancelledDesc'
  | 'createBook.upgradeToAddBooks'
  | 'createBook.trialCoversFirst'
  | 'createBook.additionalBookBlockedTitle'
  | 'createBook.additionalBookBlockedBody'
  | 'createBook.upgradeNow'
  | 'createBook.subscribePaymentDelay'
  | 'createBook.backToDashboard'
  | 'createBook.chooseYourPlan'
  | 'createBook.addAnotherBook'
  | 'createBook.startFreeOrPremium'
  | 'createBook.freePlanLabel'
  | 'createBook.allBasicFunctions'
  | 'createBook.featCreateManage'
  | 'createBook.featAddMessages'
  | 'createBook.featViewSummaries'
  | 'createBook.featShareLinks'
  | 'createBook.freeTrialBadge'
  | 'createBook.familyDiscount'
  | 'createBook.premiumBook'
  | 'createBook.unlockCollaboration'
  | 'createBook.featAllFree'
  | 'createBook.featSharedBooks'
  | 'createBook.featCustomPayment'
  | 'createBook.featOccasionInvites'
  | 'createBook.familyDiscountInfo'
  | 'createBook.familyDiscountDetails'
  | 'createBook.premiumMemberInfo'
  | 'createBook.paymentRequired'
  | 'createBook.stripeRedirect'
  | 'createBook.upgradeRequired'
  | 'createBook.existingBookTotal'
  | 'createBook.premiumFeature'
  | 'createBook.customPaymentDesc'
  | 'createBook.freeDefaultPayment'
  | 'createBook.selectRegion'
  | 'createBook.selectRegionPlaceholder'
  | 'createBook.regionUS'
  | 'createBook.regionUK'
  | 'createBook.regionDK'
  | 'createBook.regionSE'
  | 'createBook.regionEU'
  | 'createBook.bankName'
  | 'createBook.routingNumber'
  | 'createBook.sortCode'
  | 'createBook.registrationNumber'
  | 'createBook.accountType'
  | 'createBook.checkingAccount'
  | 'createBook.savingsAccount'
  | 'createBook.optional'
  | 'createBook.showSwish'
  | 'createBook.swishNumber'
  | 'createBook.swishPlaceholder'
  | 'createBook.showZelle'
  | 'createBook.zelleLabel'
  | 'createBook.zellePlaceholder'
  | 'createBook.showCashApp'
  | 'createBook.cashAppTag'
  | 'createBook.cashAppPlaceholder'
  | 'createBook.showRevolut'
  | 'createBook.revolutUsername'
  | 'createBook.revolutPlaceholder'
  | 'createBook.paymentSuccessCreating'
  | 'createBook.redirectingToStripe'
  | 'createBook.confirmAndPay'
  | 'createBook.formError'
  | 'createBook.formErrorDesc'
  | 'createBook.bankNamePlaceholderUS'
  | 'createBook.bankNamePlaceholderUK'
  | 'createBook.bankNamePlaceholderDK'
  | 'createBook.bankNamePlaceholderDefault'
  | 'createBook.accountNumberPlaceholderUK'
  | 'createBook.routingNumberPlaceholder'
  | 'createBook.sortCodePlaceholder'
  | 'createBook.regNumberPlaceholder'
  | 'createBook.ibanPlaceholderEU'
  | 'paymentInfo.statusUnknown'
  | 'paymentInfo.viewInStripe'
  | 'paymentInfo.viewInStripeDescription'
  | 'paymentInfo.noStripeAccountTitle'
  | 'paymentInfo.noStripeAccountDescription'
  | 'dashboard.toggleMobileMenu'
  | 'pricing.chooseYourPlan'
  | 'pricing.preserveMemories'
  | 'pricing.singleBook'
  | 'pricing.familyBundle'
  | 'pricing.largeFamily'
  | 'pricing.perfectForOneChild'
  | 'pricing.twoChildren'
  | 'pricing.threePlusChildren'
  | 'pricing.mostPopular'
  | 'pricing.perMonth'
  | 'pricing.perYear'
  | 'pricing.save'
  | 'pricing.perBookMonth'
  | 'pricing.allBasicFunctions'
  | 'pricing.createManageGoals'
  | 'pricing.messagesLifeAdvice'
  | 'pricing.viewContributions'
  | 'pricing.basicFamilySharing'
  | 'pricing.allBasicFunctionsFor'
  | 'pricing.sharedBooks'
  | 'pricing.sharedBooksFamily'
  | 'pricing.sharedBooksExtended'
  | 'pricing.customPaymentLinks'
  | 'pricing.customPaymentLinksEasy'
  | 'pricing.customPaymentLinksPerGoal'
  | 'pricing.occasionInvites'
  | 'pricing.occasionInvitesEvent'
  | 'pricing.occasionInvitesFull'
  | 'pricing.familyDiscount15'
  | 'pricing.familyDiscount23'
  | 'pricing.choosePlan'
  | 'pricing.startFree'
  | 'pricing.freeTrial'
  | 'pricing.singleBookFeature1'
  | 'pricing.singleBookFeature2'
  | 'pricing.singleBookFeature3'
  | 'pricing.singleBookFeature4'
  | 'pricing.singleBookFeature5'
  | 'pricing.familyBundleFeature1'
  | 'pricing.familyBundleFeature2'
  | 'pricing.familyBundleFeature3'
  | 'pricing.familyBundleFeature4'
  | 'pricing.familyBundleFeature5'
  | 'pricing.largeFamilyFeature1'
  | 'pricing.largeFamilyFeature2'
  | 'pricing.largeFamilyFeature3'
  | 'pricing.largeFamilyFeature4'
  | 'pricing.largeFamilyFeature5'
  | 'pricing.startFreeText'
  | 'pricing.freeTrialText'
  | 'pricing.saveWithPercent'
  | 'pricing.saveWithAmount'
  | 'pricing.books'
  | 'pricing.year'
  | 'pricing.numberOfBooks'
  | 'pricing.priceBreakdown'
  | 'pricing.bookN'
  | 'pricing.onPremium'
  | 'pricing.manageSubscription'
  | 'pricing.active'
  | 'pricing.activeBookSubscription'
  | 'pricing.bookSingular'
  | 'pricing.addMoreBooks'
  | 'pricing.new'
  | 'pricing.premium'
  | 'paymentInfo.freePlan'
  | 'paymentInfo.base'
  | 'paymentInfo.freeBookBasicFeatures'
  | 'paymentInfo.renewsYearly'
  | 'paymentInfo.savedWithDiscount'
  | 'paymentInfo.withBulkDiscount'
  | 'paymentInfo.needsSubscription'
  | 'paymentInfo.off'
  | 'paymentInfo.bookSubscription'
  | 'paymentInfo.premiumPerBookPricing'
  | 'pricing.oneBookIncluded'
  | 'pricing.checkoutCancelled'
  | 'pricing.checkoutCancelledDesc'
  | 'pricing.processing'
  | 'pricing.signUpPremium'
  | 'pricing.goToDashboard'
  | 'legal.termsOfService'
  | 'legal.privacyPolicy'
  | 'legal.contactUs'
  | 'legal.lastUpdated'
  | 'legal.acceptanceOfTerms'
  | 'legal.acceptanceOfTermsText'
  | 'legal.descriptionOfService'
  | 'legal.descriptionOfServiceText'
  | 'legal.userResponsibilities'
  | 'legal.userResponsibilitiesText'
  | 'legal.contentGuidelines'
  | 'legal.contentGuidelinesText'
  | 'legal.prohibitedUses'
  | 'legal.prohibitedUsesText'
  | 'legal.financialTransactions'
  | 'legal.financialTransactionsText'
  | 'legal.limitationOfLiability'
  | 'legal.limitationOfLiabilityText'
  | 'legal.changesToTerms'
  | 'legal.changesToTermsText'
  | 'legal.informationWeCollect'
  | 'legal.informationWeCollectText'
  | 'legal.howWeUseInformation'
  | 'legal.howWeUseInformationText'
  | 'legal.informationSharing'
  | 'legal.informationSharingText'
  | 'legal.yourRights'
  | 'legal.yourRightsText'
  | 'contact.contactUsTitle'
  | 'contact.contactUsSubtitle'
  | 'contact.generalSupport'
  | 'contact.generalSupportText'
  | 'contact.privacyLegal'
  | 'contact.privacyLegalText'
  | 'contact.businessInquiries'
  | 'contact.businessInquiriesText'
  | 'contact.responseTime'
  | 'ui.signIn'
  | 'ui.pricing'
  | 'ui.viewPricing'
  | 'landing.preserveImportantMomentsTitle'
  | 'landing.preserveImportantMomentsText'
  | 'landing.meaningfulPlanningTitle'
  | 'landing.meaningfulPlanningText'
  | 'landing.strengthenFamilyBondsTitle'
  | 'landing.strengthenFamilyBondsText'
  | 'landing.simpleSecurePlatformTitle'
  | 'landing.simpleSecurePlatformText'
  | 'pricing.bestValue'
  | 'pricing.unlimitedBooks'
  | 'pricing.month'
  | 'pricing.perBook'
  | 'pricing.payAsYouGo'
  | 'pricing.emailSmsInvitations'
  | 'pricing.emailSmsDescription'
  | 'pricing.perSentInvitation'
  | 'pricing.payAsYouGoDescription'
  | 'pricing.free'
  | 'pricing.recommended'
  | 'pricing.perAdditionalBook'
  | 'pricing.feature.setup_book'
  | 'pricing.feature.default_payment'
  | 'pricing.feature.add_wishes_funds'
  | 'pricing.feature.basic_sharing'
  | 'pricing.feature.custom_book_payment'
  | 'pricing.feature.custom_wish_payment'
  | 'pricing.feature.occasions_rsvp'
  | 'pricing.feature.multiple_books'
  | 'pricing.feature.share_with_family'
  | 'pricing.feature.free_invites'
  | 'pricing.feature.everything_in_free'
  | 'landing.nav.about'
  | 'landing.nav.features'
  | 'landing.nav.pricing'
  | 'landing.nav.howItWorks'
  | 'landing.nav.getStartedBtn'
  | 'landing.hero.badge'
  | 'landing.hero.title'
  | 'landing.hero.subtitle'
  | 'landing.hero.ctaPrimary'
  | 'landing.hero.value1'
  | 'landing.hero.value2'
  | 'landing.hero.value3'
  | 'landing.heroTitle1'
  | 'landing.heroTitle2'
  | 'landing.seeHowItWorks'
  | 'landing.noCreditCard'
  | 'landing.privacyFirst'
  | 'landing.cancelAnytime'
  | 'landing.howItWorksTitle'
  | 'landing.howItWorksSubtitle'
  | 'landing.step1Title'
  | 'landing.step1Desc'
  | 'landing.step2Title'
  | 'landing.step2Desc'
  | 'landing.step3Title'
  | 'landing.step3Desc'
  | 'landing.howItWorksCta'
  | 'landing.testimonialsTitle'
  | 'landing.testimonialsSubtitle'
  | 'landing.gratimyBook.badge'
  | 'landing.gratimyBook.title'
  | 'landing.gratimyBook.subtitle'
  | 'landing.testimonial1Name'
  | 'landing.testimonial1Role'
  | 'landing.testimonial1Quote'
  | 'landing.testimonial2Name'
  | 'landing.testimonial2Role'
  | 'landing.testimonial2Quote'
  | 'landing.testimonial3Name'
  | 'landing.testimonial3Role'
  | 'landing.testimonial3Quote'
  | 'landing.featuresTitle'
  | 'landing.featuresSubtitle'
  | 'landing.feature1Title'
  | 'landing.feature1Desc'
  | 'landing.feature2Title'
  | 'landing.feature2Desc'
  | 'landing.feature3Title'
  | 'landing.feature3Desc'
  | 'landing.feature4Title'
  | 'landing.feature4Desc'
  | 'landing.feature5Title'
  | 'landing.feature5Desc'
  | 'landing.feature6Title'
  | 'landing.feature6Desc'
  | 'landing.pricingNote'
  | 'landing.ctaTitle'
  | 'landing.joinBadge'
  | 'landing.impact.title'
  | 'landing.impact.subtitle'
  | 'landing.impact.tabGoal'
  | 'landing.impact.tabStock'
  | 'landing.impact.goalName'
  | 'landing.impact.goalLabel'
  | 'landing.impact.yourGift'
  | 'landing.impact.amountPlaceholder'
  | 'landing.impact.goalOf'
  | 'landing.impact.goalSupport'
  | 'landing.impact.stockReturn'
  | 'landing.impact.stockYears'
  | 'landing.impact.stockYearsUnit'
  | 'landing.impact.stockFutureValue'
  | 'landing.impact.stockGrowth'
  | 'landing.impact.stockSupport'
  | 'landing.impact.stockDisclaimer'
  | 'landing.ctaDescription'
  | 'landing.trialBadge'
  | 'landing.ctaButton'
  | 'landing.giftTitle'
  | 'landing.giftDesc'
  | 'landing.giftCta'
  | 'landing.newsletterTitle'
  | 'landing.newsletterDesc'
  | 'landing.subscribe'
  | 'landing.subscribing'
  | 'landing.cookies'
  | 'landing.footerSecurity'
  | 'landing.memoriesSubheader'
  | 'landing.stats.heading'
  | 'landing.stats.stat1Number'
  | 'landing.stats.stat1Title'
  | 'landing.stats.stat1Footnote'
  | 'landing.stats.stat2Number'
  | 'landing.stats.stat2Title'
  | 'landing.stats.stat2Footnote'
  | 'landing.stats.stat3Number'
  | 'landing.stats.stat3Title'
  | 'landing.stats.stat3Subtitle'
  | 'landing.stats.brandTitle'
  | 'landing.stats.brandSubtitle'
  | 'landing.stats.brandFootnote'
  | 'landing.stats.cta'
  | 'landing.stats.footnote2'
  | 'landing.memories.pill'
  | 'landing.memories.title'
  | 'landing.memories.card1.title'
  | 'landing.memories.card1.body'
  | 'landing.memories.card2.title'
  | 'landing.memories.card2.body'
  | 'landing.memories.card3.title'
  | 'landing.memories.card3.body'
  | 'landing.why.pill'
  | 'landing.why.subheader'
  | 'landing.stepLabel'
  | 'landing.bubble.gratitude'
  | 'landing.bubble.birthday'
  | 'landing.bubble.milestones'
  | 'landing.bubble.celebration'
  | 'landing.bubble.secure'
  | 'landing.bubble.memories'
  | 'landing.newsletterSuccess'
  | 'landing.newsletterSuccessDesc'
  | 'landing.newsletterError'
  | 'landing.newsletterErrorDesc'
  | 'waitlist.comingSoon'
  | 'waitlist.subtitle'
  | 'waitlist.emailPlaceholder'
  | 'waitlist.signup'
  | 'waitlist.signing'
  | 'waitlist.thankYou'
  | 'waitlist.thankYouDesc'
  | 'waitlist.privacy'
  | 'auth.magicLinkTitle'
  | 'auth.magicLinkDesc'
  | 'auth.sendMagicLink'
  | 'auth.sending'
  | 'auth.magicLinkSentTitle'
  | 'auth.magicLinkSentDesc'
  | 'auth.magicLinkExpiredTitle'
  | 'auth.magicLinkExpiredDesc'
  | 'auth.signingYouIn'
  | 'auth.resendLink'
  | 'auth.orSignInWithPassword'
  | 'auth.showPasswordForm'
  | 'auth.hidePasswordForm'
  | 'auth.magicLinkContributorTitle'
  | 'auth.magicLinkContributorDesc'
  | 'auth.nudgeTitle'
  | 'auth.nudgeDesc'
  | 'auth.nudgeCta'
  | 'auth.nudgeSent'
  | 'auth.signupConfirmTitle'
  | 'auth.signupConfirmDesc'
  | 'auth.creatingAccount'
  | 'auth.createAccount'
  | 'auth.consentRequired'
  | 'auth.consentRequiredDesc'
  | 'auth.gdprConsentLabel'
  | 'auth.marketingConsentLabel'
  | 'auth.passwordMinLength'
  | 'dashboard.welcomeBack'
  | 'dashboard.welcomeStatsPrefix'
  | 'dashboard.welcomeStatsLink'
  | 'dashboard.back'
  | 'dashboard.notifications'
  | 'dashboard.addGiftEntry'
  | 'dashboard.sharedBadge'
  | 'dashboard.viewOnlyBadge'
  | 'dashboard.edit_book'
  | 'dashboard.view_book'
  | 'dashboard.notif.empty'
  | 'dashboard.notif.birthdaySoon'
  | 'dashboard.notif.birthdayHint'
  | 'dashboard.notif.trialSubtitle'
  | 'dashboard.notif.occasionSoon'
  | 'dashboard.notif.actionSendGift'
  | 'dashboard.notif.actionSendCongrats'
  | 'dashboard.notif.actionSurprise'
  | 'dashboard.notif.newGiftSingular'
  | 'dashboard.notif.newGiftPlural'
  | 'dashboard.notif.newGiftSubtitle'
  | 'dashboard.notif.actionView'
  | 'dashboard.notif.scrollLabel'
  | 'dashboard.notif.pageLabel'
  | 'account.profileImage.title'
  | 'account.profileImage.upload'
  | 'account.profileImage.remove'
  | 'account.profileImage.uploading'
  | 'account.profileImage.success'
  | 'account.profileImage.error'
  | 'account.profileImage.removed'
  | 'account.profileImage.help'
  | 'account.profileImage.maxSize'
  | 'footer.tagline'
  | 'footer.product'
  | 'footer.company'
  | 'footer.dashboard'
  | 'footer.howItWorks'
  | 'footer.pricing'
  | 'footer.giftGratimy'
  | 'footer.contact'
  | 'footer.privacyPolicy'
  | 'footer.terms'
  | 'footer.cookies'
  | 'footer.newsletter'
  | 'footer.newsletterDesc'
  | 'footer.emailPlaceholder'
  | 'footer.subscribe'
  | 'footer.subscribeSuccess'
  | 'footer.subscribeError'
  | 'footer.rights'
  | 'footer.writeReview'
  | 'landing.reviews.viewAll'
  | 'landing.reviews.showLess'
  | 'landing.reviews.empty'
  | 'landing.reviews.scrollLeft'
  | 'landing.reviews.scrollRight'
  | 'landing.reviews.anonymous'
  | 'reviewModal.title'
  | 'reviewModal.subtitle'
  | 'reviewModal.ratingLabel'
  | 'reviewModal.ratingHint'
  | 'reviewModal.bodyLabel'
  | 'reviewModal.bodyPlaceholder'
  | 'reviewModal.postAs'
  | 'reviewModal.postAnonymously'
  | 'reviewModal.cancel'
  | 'reviewModal.submit'
  | 'reviewModal.update'
  | 'reviewModal.starAria'
  | 'landing.reviews.badge'
  | 'landing.reviews.ratedSummary'
  | 'landing.reviews.imageAlt'
  | 'landing.reviews.loadError'
  | 'reviewModal.submitting'
  | 'reviewModal.successTitle'
  | 'reviewModal.successDesc'
  | 'reviewModal.errorTitle'
  | 'reviewModal.errorDesc'
  | 'reviewModal.validationRating'
  | 'reviewModal.validationBody'
  | 'reviewModal.close'
  | 'gift_table.page_title'
  | 'gift_table.gift_count'
  | 'gift_table.gift_count_singular'
  | 'gift_table.empty_title'
  | 'gift_table.empty_description'
  | 'gift_table.back_to_book'
  | 'gift_table.return_to_book'
  | 'gift_table.from'
  | 'gift_table.bubble_aria'
  | 'gift_table.bubble_aria_with_occasion'
  | 'privacy.info_collect_title'
  | 'privacy.info_collect_body'
  | 'privacy.how_use_title'
  | 'privacy.how_use_body'
  | 'privacy.sharing_title'
  | 'privacy.sharing_body'
  | 'privacy.processors_title'
  | 'privacy.processors_body'
  | 'privacy.label_purpose'
  | 'privacy.label_data_shared'
  | 'privacy.label_data_location'
  | 'privacy.label_legal_basis'
  | 'privacy.label_privacy_policy'
  | 'privacy.label_note'
  | 'privacy.label_optout'
  | 'privacy.legal_contract'
  | 'privacy.legal_consent'
  | 'privacy.data_location_eu'
  | 'privacy.google_link'
  | 'privacy.auth_services_title'
  | 'privacy.supabase_auth_name'
  | 'privacy.supabase_auth_purpose'
  | 'privacy.supabase_auth_data'
  | 'privacy.db_infra_title'
  | 'privacy.supabase_db_name'
  | 'privacy.supabase_db_purpose'
  | 'privacy.supabase_db_data'
  | 'privacy.payment_title'
  | 'privacy.stripe_name'
  | 'privacy.stripe_purpose'
  | 'privacy.stripe_data'
  | 'privacy.email_title'
  | 'privacy.aws_name'
  | 'privacy.aws_purpose'
  | 'privacy.aws_data'
  | 'privacy.aws_legal'
  | 'privacy.aws_link'
  | 'privacy.analytics_title'
  | 'privacy.ga_name'
  | 'privacy.ga_purpose'
  | 'privacy.ga_data'
  | 'privacy.ga_note'
  | 'privacy.advertising_title'
  | 'privacy.google_ads_name'
  | 'privacy.google_ads_purpose'
  | 'privacy.google_ads_data'
  | 'privacy.google_ads_optout_pre'
  | 'privacy.google_ads_settings_link'
  | 'privacy.google_ads_optout_post'
  | 'privacy.storage_title'
  | 'privacy.supabase_storage_name'
  | 'privacy.supabase_storage_purpose'
  | 'privacy.supabase_storage_data'
  | 'privacy.safeguards_title'
  | 'privacy.safeguards_intro'
  | 'privacy.safeguards_1'
  | 'privacy.safeguards_2'
  | 'privacy.safeguards_3'
  | 'privacy.safeguards_4'
  | 'privacy.safeguards_5'
  | 'privacy.intl_title'
  | 'privacy.intl_intro'
  | 'privacy.intl_1'
  | 'privacy.intl_2'
  | 'privacy.intl_3'
  | 'privacy.security_title'
  | 'privacy.security_body'
  | 'privacy.rights_title'
  | 'privacy.rights_body'
  | 'privacy.contact_title'
  | 'privacy.contact_pre'
  | 'onboarding.step.name'
  | 'onboarding.step.address'
  | 'onboarding.step.region'
  | 'onboarding.step.contact'
  | 'onboarding.step.banking'
  | 'onboarding.step.trial'
  | 'onboarding.title'
  | 'onboarding.subtitle'
  | 'onboarding.toast.error_title'
  | 'onboarding.toast.save_profile_error'
  | 'onboarding.toast.trial_activated_title'
  | 'onboarding.toast.trial_activated_desc'
  | 'onboarding.toast.activate_trial_error'
  | 'onboarding.toast.gift_redeemed_title'
  | 'onboarding.toast.gift_redeemed_desc'
  | 'onboarding.toast.redemption_failed_title'
  | 'onboarding.toast.redemption_failed_desc'
  | 'onboarding.toast.welcome_title'
  | 'onboarding.toast.welcome_later'
  | 'onboarding.toast.welcome_done'
  | 'onboarding.toast.missing_info_title'
  | 'onboarding.toast.missing_info_desc'
  | 'onboarding.toast.enter_gift_code'
  | 'onboarding.name.heading'
  | 'onboarding.name.first_label'
  | 'onboarding.name.first_placeholder'
  | 'onboarding.name.last_label'
  | 'onboarding.name.last_placeholder'
  | 'onboarding.address.heading'
  | 'onboarding.address.subtitle'
  | 'onboarding.address.street_label'
  | 'onboarding.address.street_placeholder'
  | 'onboarding.address.city_label'
  | 'onboarding.address.city_placeholder'
  | 'onboarding.address.postal_label'
  | 'onboarding.address.postal_placeholder'
  | 'onboarding.region.heading'
  | 'onboarding.region.subtitle'
  | 'onboarding.region.country_label'
  | 'onboarding.region.country_select'
  | 'onboarding.country.dk'
  | 'onboarding.country.us'
  | 'onboarding.country.gb'
  | 'onboarding.country.se'
  | 'onboarding.country.no'
  | 'onboarding.country.fi'
  | 'onboarding.country.de'
  | 'onboarding.country.fr'
  | 'onboarding.country.nl'
  | 'onboarding.country.be'
  | 'onboarding.country.at'
  | 'onboarding.country.ch'
  | 'onboarding.country.es'
  | 'onboarding.country.it'
  | 'onboarding.country.pt'
  | 'onboarding.country.pl'
  | 'onboarding.country.ie'
  | 'onboarding.country.ca'
  | 'onboarding.country.au'
  | 'onboarding.country.nz'
  | 'onboarding.region.currency_label'
  | 'onboarding.currency.usd'
  | 'onboarding.currency.eur'
  | 'onboarding.currency.gbp'
  | 'onboarding.currency.dkk'
  | 'onboarding.contact.heading'
  | 'onboarding.contact.subtitle'
  | 'onboarding.contact.phone_label'
  | 'onboarding.contact.phone_placeholder'
  | 'onboarding.contact.skip_hint'
  | 'onboarding.banking.heading'
  | 'onboarding.banking.subtitle'
  | 'onboarding.banking.bank_name_label'
  | 'onboarding.banking.bank_name_placeholder'
  | 'onboarding.banking.account_number_label'
  | 'onboarding.banking.account_number_placeholder'
  | 'onboarding.banking.reg_number_label'
  | 'onboarding.banking.reg_number_placeholder'
  | 'onboarding.banking.iban_label'
  | 'onboarding.banking.iban_placeholder'
  | 'onboarding.banking.skip_hint'
  | 'onboarding.trial.heading'
  | 'onboarding.trial.subtitle'
  | 'onboarding.trial.features_title'
  | 'onboarding.trial.feature1'
  | 'onboarding.trial.feature2'
  | 'onboarding.trial.feature3'
  | 'onboarding.trial.feature4'
  | 'onboarding.trial.free_access'
  | 'onboarding.trial.activating'
  | 'onboarding.trial.activate_now'
  | 'onboarding.trial.save_later'
  | 'onboarding.trial.or'
  | 'onboarding.trial.have_gift_code'
  | 'onboarding.trial.redeem_gift_code'
  | 'onboarding.trial.gift_code_placeholder'
  | 'onboarding.trial.redeeming'
  | 'onboarding.trial.activate_later_hint'
  | 'onboarding.nav.previous'
  | 'onboarding.nav.next'
  | 'onboarding.nav.saving'
  | 'onboarding.nav.continue'
  | 'onboarding.progress_alt'
  | 'account.toast_session_expired_title'
  | 'account.toast_session_expired_desc'
  | 'account.toast_currency_required_title'
  | 'account.toast_currency_required_desc'
  | 'account.toast_data_exported_title'
  | 'account.toast_data_exported_desc'
  | 'account.toast_export_failed_title'
  | 'account.toast_export_failed_desc'
  | 'account.toast_invalid_confirmation_title'
  | 'account.toast_invalid_confirmation_desc'
  | 'account.toast_account_deleted_title'
  | 'account.toast_account_deleted_desc'
  | 'account.toast_deletion_failed_title'
  | 'account.toast_deletion_failed_desc'
  | 'account.toast_missing_info_title'
  | 'account.toast_missing_info_desc'
  | 'account.toast_rectification_submitted_title'
  | 'account.toast_rectification_submitted_desc'
  | 'account.toast_request_failed_title'
  | 'account.toast_request_failed_desc'
  | 'account.toast_error_title'
  | 'account.toast_consent_history_error'
  | 'account.placeholder_your_name'
  | 'account.placeholder_street'
  | 'account.placeholder_city'
  | 'account.placeholder_postal'
  | 'account.placeholder_bank_us'
  | 'account.placeholder_account_number'
  | 'account.placeholder_routing'
  | 'account.placeholder_bank_dk'
  | 'account.placeholder_reg_number'
  | 'account.placeholder_bank_uk'
  | 'account.placeholder_account_number_8'
  | 'account.placeholder_sort_code'
  | 'account.placeholder_bank_intl'
  | 'account.placeholder_iban_intl'
  | 'account.placeholder_bic_swift'
  | 'account.country_select'
  | 'account.country_DK'
  | 'account.country_US'
  | 'account.country_GB'
  | 'account.country_SE'
  | 'account.country_NO'
  | 'account.country_FI'
  | 'account.country_DE'
  | 'account.country_FR'
  | 'account.country_NL'
  | 'account.country_BE'
  | 'account.country_AT'
  | 'account.country_CH'
  | 'account.country_ES'
  | 'account.country_IT'
  | 'account.country_PT'
  | 'account.country_PL'
  | 'account.country_IE'
  | 'account.country_CA'
  | 'account.country_AU'
  | 'account.country_NZ'
  | 'account.optional'
  | 'account.generating_pdf'
  | 'account.close'
  | 'account.cancel'
  | 'account.rectify_title'
  | 'account.rectify_desc'
  | 'account.rectify_field_name'
  | 'account.rectify_field_name_placeholder'
  | 'account.rectify_current_value'
  | 'account.rectify_current_value_placeholder'
  | 'account.rectify_requested_value'
  | 'account.rectify_requested_value_placeholder'
  | 'account.rectify_reason'
  | 'account.rectify_reason_placeholder'
  | 'account.rectify_submit'
  | 'account.consent_title'
  | 'account.consent_desc'
  | 'account.consent_empty'
  | 'account.consent_type_marketing'
  | 'account.consent_type_terms'
  | 'account.consent_granted'
  | 'account.consent_revoked'
  | 'account.consent_previously'
  | 'account.consent_previously_granted'
  | 'account.consent_previously_revoked'
  | 'account.delete_title'
  | 'account.delete_cannot_undo'
  | 'account.delete_intro'
  | 'account.delete_item_books'
  | 'account.delete_item_gifts'
  | 'account.delete_item_goals'
  | 'account.delete_item_profile'
  | 'account.delete_item_shared'
  | 'account.delete_type_prefix'
  | 'account.delete_type_suffix'
  | 'account.delete_confirm'
  | 'newsletter.title'
  | 'newsletter.toast_success_title'
  | 'newsletter.toast_success_desc'
  | 'newsletter.toast_fail_title'
  | 'newsletter.toast_fail_desc'
  | 'newsletter.success_title'
  | 'newsletter.success_desc'
  | 'newsletter.intro'
  | 'newsletter.email_label'
  | 'newsletter.gdpr_before'
  | 'newsletter.privacy_policy'
  | 'newsletter.gdpr_after'
  | 'newsletter.subscribing'
  | 'newsletter.subscribe'
  | 'share_occasion.sent_new_and_skipped'
  | 'share_occasion.sent_to_count'
  | 'share_occasion.all_already_invited'
  | 'share_occasion.invitations_sent'
  | 'share_occasion.invitations_sent_title'
  | 'share_occasion.send_error_title'
  | 'share_occasion.send_error_description'
  | 'share_occasion.link_copied_title'
  | 'share_occasion.link_copied_description'
  | 'share_occasion.link_ready_title'
  | 'share_occasion.link_error_description'
  | 'share_occasion.copied_again_title'
  | 'share_occasion.copied_again_description'
  | 'share_occasion.share_link_title'
  | 'share_occasion.missing_emails_title'
  | 'share_occasion.missing_emails_description'
  | 'share_occasion.missing_wishlist_url_title'
  | 'share_occasion.missing_wishlist_url_description'
  | 'share_occasion.consent_required_title'
  | 'share_occasion.consent_required_description'
  | 'share_occasion.duplicate_emails_title'
  | 'share_occasion.duplicate_emails_description'
  | 'share_occasion.modal_title'
  | 'share_occasion.modal_description'
  | 'share_occasion.already_invited_count'
  | 'share_occasion.already_invited_note'
  | 'share_occasion.include_wishlist'
  | 'share_occasion.wishlist_url_placeholder'
  | 'share_occasion.wishlist_info'
  | 'share_occasion.regular_guests_label'
  | 'share_occasion.emails_placeholder'
  | 'share_occasion.regular_guests_description'
  | 'share_occasion.wishlist_family_label'
  | 'share_occasion.wishlist_family_description'
  | 'share_occasion.gdpr_consent_intro'
  | 'share_occasion.gdpr_privacy_policy'
  | 'share_occasion.gdpr_and'
  | 'share_occasion.gdpr_terms'
  | 'share_occasion.button_sending'
  | 'share_occasion.button_send'
  | 'share_occasion.or'
  | 'share_occasion.generating'
  | 'guest_list.guest_added_title'
  | 'guest_list.guest_added_description'
  | 'guest_list.add_error_title'
  | 'guest_list.add_error_description'
  | 'guest_list.update_error_title'
  | 'guest_list.update_error_description'
  | 'guest_list.guest_removed_title'
  | 'guest_list.guest_removed_description'
  | 'guest_list.remove_error_title'
  | 'guest_list.remove_error_description'
  | 'guest_list.email_required_title'
  | 'guest_list.email_required_description'
  | 'guest_list.delete_confirm'
  | 'guest_list.back'
  | 'guest_list.title'
  | 'guest_list.add_guest'
  | 'guest_list.no_guests_title'
  | 'guest_list.no_guests_description'
  | 'guest_list.add_first_guest'
  | 'guest_list.column_guest'
  | 'guest_list.column_count'
  | 'guest_list.column_type'
  | 'guest_list.column_invite_sent'
  | 'guest_list.column_attending'
  | 'guest_list.column_not_attending'
  | 'guest_list.person'
  | 'guest_list.persons'
  | 'guest_list.type_wishlist_family'
  | 'guest_list.type_guest'
  | 'guest_list.add_modal_title'
  | 'guest_list.add_modal_description'
  | 'guest_list.email_label'
  | 'guest_list.email_placeholder'
  | 'guest_list.name_label'
  | 'guest_list.name_placeholder'
  | 'guest_list.guest_count_label'
  | 'guest_list.guest_count_placeholder'
  | 'guest_list.guest_count_help'
  | 'guest_list.wishlist_recipient_label'
  | 'guest_list.cancel'
  | 'guest_list.adding'
  | 'goal_form.update_error_fallback'
  | 'goal_form.create_error_fallback'
  | 'goal_form.cover_label'
  | 'goal_form.cover_helper'
  | 'goal_form.cover_choose'
  | 'goal_form.cover_change'
  | 'goal_form.cover_remove'
  | 'goal_form.cover_invalid_type'
  | 'goal_form.cover_too_large'
  | 'goal_form.cover_upload_failed_title'
  | 'goal_form.cover_upload_failed_desc'
  | 'goal_form.wish_updated_title'
  | 'goal_form.wish_created_title'
  | 'goal_form.wish_updated_desc'
  | 'goal_form.wish_created_desc'
  | 'goal_form.update_error_title'
  | 'goal_form.create_error_title'
  | 'goal_form.update_error_desc'
  | 'goal_form.create_error_desc'
  | 'goal_form.missing_info_title'
  | 'goal_form.fund_name_required'
  | 'goal_form.calculation_amount_min'
  | 'goal_form.target_amount_min'
  | 'goal_form.currency_kr'
  | 'goal_form.initial_amount_label'
  | 'goal_form.calculation_amount_label'
  | 'goal_form.fund_name_label'
  | 'goal_form.fund_name_placeholder'
  | 'goal_form.choose_payment_method'
  | 'goal_form.select_payment_method_placeholder'
  | 'goal_form.bank_name_label'
  | 'goal_form.bank_name_placeholder_us'
  | 'goal_form.bank_name_placeholder_uk'
  | 'goal_form.bank_name_placeholder_dkse'
  | 'goal_form.bank_name_placeholder_default'
  | 'goal_form.iban_label'
  | 'goal_form.iban_placeholder'
  | 'goal_form.bic_swift_label'
  | 'goal_form.bic_swift_placeholder'
  | 'goal_form.routing_number_label'
  | 'goal_form.sort_code_label'
  | 'goal_form.registration_number_label'
  | 'goal_form.routing_placeholder_us'
  | 'goal_form.routing_placeholder_uk'
  | 'goal_form.routing_placeholder_default'
  | 'goal_form.account_number_label'
  | 'goal_form.account_placeholder_uk'
  | 'goal_form.account_placeholder_default'
  | 'goal_form.payment_reference_label'
  | 'goal_form.optional'
  | 'goal_form.payment_reference_placeholder_with_title'
  | 'goal_form.payment_reference_placeholder_default'
  | 'payment_reminder.default_message'
  | 'payment_reminder.sent_title'
  | 'payment_reminder.sent_desc'
  | 'payment_reminder.error_title'
  | 'payment_reminder.error_desc'
  | 'payment_reminder.preview_title'
  | 'payment_reminder.send_title'
  | 'payment_reminder.preview_intro'
  | 'payment_reminder.reminder_label'
  | 'payment_reminder.to_line'
  | 'payment_reminder.from_line'
  | 'payment_reminder.payment_details_label'
  | 'payment_reminder.bank_transfer'
  | 'payment_reminder.reg_no'
  | 'payment_reminder.account_no'
  | 'payment_reminder.preview_note'
  | 'payment_reminder.edit_message'
  | 'payment_reminder.cancel'
  | 'payment_reminder.sending'
  | 'payment_reminder.send_reminder'
  | 'payment_reminder.email_label'
  | 'payment_reminder.email_placeholder'
  | 'payment_reminder.email_description'
  | 'payment_reminder.message_label'
  | 'payment_reminder.message_placeholder'
  | 'payment_reminder.message_description'
  | 'payment_reminder.preview_toggle_label'
  | 'payment_reminder.preview_toggle_desc'
  | 'payment_reminder.preview_reminder'
  | 'login_page.error_title'
  | 'login_page.magic_link_failed'
  | 'login_page.resend_failed'
  | 'login_page.login_failed_title'
  | 'login_page.invalid_credentials'
  | 'login_page.welcome_back_title'
  | 'login_page.login_success'
  | 'login_page.email_required_title'
  | 'login_page.email_required_desc'
  | 'login_page.reset_link_failed'
  | 'login_page.check_email_title'
  | 'login_page.check_email_desc'
  | 'login_page.signup_failed_title'
  | 'login_page.signup_failed_desc'
  | 'login_page.signing_in'
  | 'login_page.secure_auth'
  | 'login_page.data_encrypted'
  | 'login_page.reset_dialog_title'
  | 'login_page.reset_dialog_desc'
  | 'login_page.email_address'
  | 'login_page.cancel'
  | 'login_page.sending'
  | 'login_page.send_reset_link'
  | 'reset_pw.password_min_length'
  | 'reset_pw.passwords_no_match'
  | 'reset_pw.update_failed'
  | 'reset_pw.updated_toast_title'
  | 'reset_pw.updated_toast_desc'
  | 'reset_pw.verifying'
  | 'reset_pw.updated_title'
  | 'reset_pw.updated_desc'
  | 'reset_pw.redirecting'
  | 'reset_pw.invalid_title'
  | 'reset_pw.invalid_desc'
  | 'reset_pw.back_to_login'
  | 'reset_pw.create_title'
  | 'reset_pw.create_desc'
  | 'reset_pw.new_password'
  | 'reset_pw.min_chars'
  | 'reset_pw.confirm_password'
  | 'reset_pw.updating'
  | 'reset_pw.update_button'
  | 'shared_books.success_title'
  | 'shared_books.shared_success'
  | 'shared_books.error_title'
  | 'shared_books.share_failed'
  | 'shared_books.removed_success'
  | 'shared_books.remove_failed'
  | 'shared_books.accepted_success'
  | 'shared_books.accept_failed'
  | 'shared_books.declined_title'
  | 'shared_books.declined_desc'
  | 'shared_books.decline_failed'
  | 'shared_books.enter_email_select'
  | 'shared_books.title'
  | 'shared_books.tab_share'
  | 'shared_books.tab_received'
  | 'shared_books.tab_sent'
  | 'shared_books.invite_someone'
  | 'shared_books.email_address'
  | 'shared_books.enter_email_placeholder'
  | 'shared_books.select_books'
  | 'shared_books.no_books_available'
  | 'shared_books.childs_book'
  | 'shared_books.sharing'
  | 'shared_books.share_selected'
  | 'shared_books.none_shared_with_you'
  | 'shared_books.book_fallback'
  | 'shared_books.shared_with_you'
  | 'shared_books.accepted'
  | 'shared_books.accept'
  | 'shared_books.decline'
  | 'shared_books.none_shared_by_you'
  | 'shared_books.shared_with'
  | 'shared_books.pending'
  | 'shared_books.remove_pending'
  | 'share_accept.invalid_link'
  | 'share_accept.invalid_link_desc'
  | 'share_accept.success'
  | 'share_accept.success_desc'
  | 'share_accept.error'
  | 'share_accept.accept_failed'
  | 'share_accept.send_link_failed'
  | 'share_accept.processing'
  | 'share_accept.auto_accept_note'
  | 'share_accept.or'
  | 'share_accept.login_existing'
  | 'share_accept.create_account'
  | 'share_accept.accepting'
  | 'ownership.invalid_link'
  | 'ownership.invalid_link_desc'
  | 'ownership.processing'
  | 'ownership.accepting'
  | 'ownership.success'
  | 'ownership.success_desc'
  | 'ownership.error'
  | 'ownership.error_desc'
  | 'ownership.title'
  | 'ownership.desc'
  | 'ownership.magic_link_sent_title'
  | 'ownership.magic_link_sent_desc'
  | 'ownership.magic_link_note'
  | 'ownership.email'
  | 'ownership.sending'
  | 'ownership.send_magic_link'
  | 'ownership.login_existing'
  | 'ownership.create_account'
  | 'ownership.or'
  | 'ownership.send_link_failed'
  | 'giver_photo.invalid_file_type'
  | 'giver_photo.invalid_file_type_desc'
  | 'giver_photo.file_too_large'
  | 'giver_photo.file_too_large_desc'
  | 'giver_photo.photo_added'
  | 'giver_photo.photo_added_desc'
  | 'giver_photo.upload_failed'
  | 'giver_photo.upload_failed_desc'
  | 'giver_photo.photo_attached'
  | 'giver_photo.photo_attached_desc'
  | 'giver_photo.error'
  | 'giver_photo.attach_failed'
  | 'giver_photo.photo_removed'
  | 'giver_photo.remove_failed'
  | 'giver_photo.click_or_drop_change'
  | 'giver_photo.drag_drop_here'
  | 'giver_photo.png_jpg_limit'
  | 'giver_photo.dialog_title'
  | 'giver_photo.no_photos_yet'
  | 'giver_photo.giver_name_placeholder'
  | 'giver_photo.uploading'
  | 'giver_photo.upload_new'
  | 'giver_photo.cancel'
  | 'giver_photo.remove'
  | 'currency_sel.usd_name'
  | 'currency_sel.usd_region'
  | 'currency_sel.eur_name'
  | 'currency_sel.eur_region'
  | 'currency_sel.gbp_name'
  | 'currency_sel.gbp_region'
  | 'currency_sel.dkk_name'
  | 'currency_sel.dkk_region'
  | 'currency_sel.detecting'
  | 'currency_sel.preference'
  | 'currency_sel.auto_detected'
  | 'currency_sel.search_placeholder'
  | 'currency_sel.no_currency_found'
  | 'time_picker.select_time'
  | 'time_picker.hour'
  | 'time_picker.min'
  | 'form_error.correct_errors'
  | 'image.failed_to_load'
  | 'protected.loading'
  | 'protected.redirecting'
  | 'guest_btn.guest_list'
  | 'pricing_extra.email_placeholder'
  | 'pricing_extra.enter_gift_code';

const translationsCache: Partial<Record<Language, Record<TranslationKey, string>>> = {};
let activeTranslations: Partial<Record<TranslationKey, string>> = {};
let currentLanguage: Language = 'en';
let loadToken = 0;

const loaders: Record<Language, () => Promise<{ default: Record<TranslationKey, string> }>> = {
  da: () => import('./locales/da'),
  en: () => import('./locales/en'),
};

export async function loadTranslations(lang: Language): Promise<void> {
  const token = ++loadToken;
  if (translationsCache[lang]) {
    if (token === loadToken) {
      activeTranslations = translationsCache[lang]!;
    }
    return;
  }
  try {
    const mod = await loaders[lang]();
    translationsCache[lang] = mod.default;
    if (token === loadToken) {
      activeTranslations = mod.default;
    }
  } catch {
    if (token === loadToken && lang !== 'en') {
      await loadTranslations('en');
    }
  }
}

export function isLanguageLoaded(lang: Language): boolean {
  return !!translationsCache[lang];
}

export function t(key: TranslationKey, params?: Record<string, string>): string {
  const savedLanguage = localStorage.getItem('app-language') as Language;
  const lang = (savedLanguage && (savedLanguage === 'da' || savedLanguage === 'en')) ? savedLanguage : currentLanguage;

  const source = translationsCache[lang] || activeTranslations;
  const translatedText = source[key] || key;

  if (params) {
    return Object.entries(params).reduce((text, [param, value]) => {
      return text.replace(new RegExp(`{{${param}}}`, 'g'), value);
    }, translatedText);
  }

  return translatedText;
}

export function setLanguage(language: Language): void {
  currentLanguage = language;
  localStorage.setItem('app-language', language);

  if (translationsCache[language]) {
    activeTranslations = translationsCache[language]!;
    window.dispatchEvent(new CustomEvent('language-changed', { detail: language }));
  } else {
    loadTranslations(language).then(() => {
      if (currentLanguage === language) {
        window.dispatchEvent(new CustomEvent('language-changed', { detail: language }));
      }
    });
  }
}

export function getLanguage(): Language {
  return currentLanguage;
}

export function initLanguage(): void {
  const savedLanguage = localStorage.getItem('app-language') as Language;
  if (savedLanguage && (savedLanguage === 'da' || savedLanguage === 'en')) {
    currentLanguage = savedLanguage;
  }
}
